import React, { useEffect, useState } from 'react';
import styles from './timesheet.module.scss';
import { KoButton, KoDateFormatter, KoDP, KoEmpty, KoForm,  KoLoader, KoModal, KoTable, KoTag, KoText, KoTitle, KoToast, KoTooltips, KoUserSelect } from 'packages';
import KoIcon from '@kwapio/icons';
import { formatDateRange } from 'shared/utils';
import { KoTicketTable_COLUMNS } from './constant';
import { useSelector } from 'react-redux';
import { ProfileAPI } from 'pages/profile/profile.service';
import TimeSheetCurd from './crud';
import { WORKLOG_COLUMNS } from '../constant';
import { useDispatch } from 'react-redux';
import { getTimeSheetCount } from 'shared/store/timesheetCountSlice';
import { getApprovalCount } from 'shared/store/approvalCountSlice';
export default function SheetDetails({ project, showCreate, setOpenWorkspaceModal, getWorkspaces }) {
  const [isOpen, setModal] = useState(false);
  const users = useSelector(state => state?.users);
  const [openSubmitModal, setSubmitModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [logsByDateRange, setLogsByDateRange] = useState();
  const [, setworkHourSections] = useState([]);
  const [currentRecord, setCurrentRecord] = useState();
  const [isOpenDelete, setDeleteModal] = useState(false);
  const [isOpenWorkLog, setWorkLogModal] = useState(false);
  const [selectedApprover, setSelectedApprover] = useState();
  const [workLogHistory, setWorkLogHistory] = useState();
  const [currentPeriod, setCurrentPeriod] = useState();
  const [cancelConfirm, setCancelConfirm] = useState(false);
  const [intervals, setIntervals] = useState();
  const [totalLogs, setTotalLogs] = useState();
  const [form] = KoForm.useForm();
  const dispatch = useDispatch();
  useEffect(() => {
    getIntervals();
  }, [project]);


  const getIntervals = (status) => {
    setLoading(true);
    if (project) {
      let q = {
        status: project?.status
      };
      if(status === 'waiting'){
        q['status'] = 1;
      }else if(status === 'cancel' || status === 'move'){
        q['status'] = (project?.status === 4 || project?.status === 5) ? 4 : 0;
      }else if(status === 'all'){
        q['status'] = "0,1,2,3,4,5";
      }
      ProfileAPI.getIntervals(project?.workspace, q).then(
        (data) => {
          setLoading(false);
          let cp = (!status && currentPeriod) ? currentPeriod : data?.intervals[0];
          setCurrentPeriod(cp);
          if (project?.status === "0,1,2,3,4,5" || q['status'] === '0,1,2,3,4,5') {
            const filteredIntervals = filterIntervals(data?.intervals);
            setIntervals(filteredIntervals);
          } else {
            setIntervals(data?.intervals);
          }

          getWorkLogs(cp?.intervalStart, cp?.intervalEnd, project?.workspace, cp?.status);
        },
        (err) => {
          setLoading(false);
        }
      );
    }
  };

  const updateCurrentPeriod = (item, workspace) => {
    setLoading(true);
    setCurrentPeriod(item);
    getWorkLogs(item?.intervalStart, item?.intervalEnd, workspace, item?.status);
  };

  function filterIntervals(intervals) {
    const today = new Date();
    const dayOfWeek = today.getUTCDay();
    const daysUntilSaturday = 6 - dayOfWeek;
    const endOfWeek = new Date(today);
    endOfWeek.setUTCDate(today.getUTCDate() + daysUntilSaturday);
    endOfWeek.setUTCHours(23, 59, 59, 999);

// Filter intervals up to current week's Saturday
    const filtered = intervals.filter(interval => {
      return new Date(interval.intervalEnd + "T23:59:59Z") <= endOfWeek;
    });
    return filtered;
  }


  const getWorkLogs = (startDate, endDate, workspace, status) => {
    setLoading(true);
    const query = {
      startDate: startDate,
      endDate: endDate,
      status: (status === 4 || status === 5) ? 0 : status
    };
   
    if (!workspace) {
      return;
    }

    ProfileAPI.getAllWorkLogsTime(query, workspace).then(
      (data) => {
        setLoading(false);
        setLogsByDateRange(data['workLogs']);
        let nonticketLogs = data['workLogs']?.nonticketLogs?.logs || [];
        let ticketLogs = data['workLogs']?.ticketLogs?.logs || [];
        const workHourSections = [
          {
            label: "Billable Hours", withTickets: data['workLogs']?.ticketLogs?.totalBillableWorkHours,
            withoutTickets: data['workLogs']?.nonticketLogs?.totalBillableWorkHours,
            total: data['workLogs']?.ticketLogs?.totalBillableWorkHours
          },
          {
            label: "Non-Billable Hours", withTickets: data['workLogs']?.ticketLogs?.totalNonBillableWorkHours,
            withoutTickets: data['workLogs']?.nonticketLogs?.totalNonBillableWorkHours,
            total: data['workLogs']?.ticketLogs?.totalNonBillableWorkHours
          }
        ];
        setworkHourSections(workHourSections);
        setTotalLogs([...nonticketLogs, ...ticketLogs]);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleFinish = (values) => {
    setLoading(true);
    values['startDate'] = currentPeriod?.startDate;
    values['endDate'] = currentPeriod?.endDate;
    if(values['task']?.length > 0){
      values['task'] = [values['task']];
    }
    ProfileAPI.createOrUpdateTimesheet(values, currentRecord?.workLogId, project?.workspace).then(
      (data) => {
        setLoading(false);
        dispatch(getTimeSheetCount());
        setWorkLogModal(false);
        getWorkspaces();
        dispatch(getApprovalCount());
        getIntervals();
        getWorkLogs(currentPeriod?.intervalStart, currentPeriod?.intervalEnd, project?.workspace, currentPeriod?.status);
        setModal(false);
        KoToast.success(`Timesheet ${currentRecord?.workLogId ? 'updated' : 'created'} successfully`);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleFinishDelete = () => {
    setLoading(true);
    ProfileAPI.deleteTimesheetById(currentRecord?.workLogId, project?.workspace).then(
      (data) => {
        getWorkLogs(currentPeriod?.intervalStart, currentPeriod?.intervalEnd, project?.workspace, currentPeriod?.status);
        setLoading(false);
        setDeleteModal(false);
        getIntervals();
        getWorkspaces();
        dispatch(getApprovalCount());
        setWorkLogModal(false);
        KoToast.success(`Log deleted successfully!`);
      },
      (err) => {
        setLoading(false);
        KoToast.error(`error`);
      }
    );
  };

  const onExtraClick = (record) => {
    setWorkLogModal(true);
    setWorkLogHistory(record?.logs || []);
  };

  const cancelTimeSheet = (item) => {
    setLoading(true);
    let data = {
      status: 0
    };
    let q = {
      startDate: currentPeriod?.intervalStart,
      endDate: currentPeriod?.intervalEnd
    };
    ProfileAPI.cancelTimesheet(data, q, item?.workspace).then(
      (data) => {
        setLoading(false);
        getIntervals('cancel');
        setCancelConfirm(false);
        // getWorkLogs(currentPeriod?.intervalStart, currentPeriod?.intervalEnd, project?.workspace, currentPeriod?.status);
        // setOpenWorkspaceModal(false);
        dispatch(getApprovalCount());
        getWorkspaces();
        KoToast.success(`Timesheet cancelled successfully!`);
      },
      (err) => {
        setLoading(false);
        KoToast.error(`error`);
      }
    );
  };


  const sendApprovalRequest = () => {
    setLoading(true);
    let data = {
      status: 1,
      approver: selectedApprover || project?.reportingTo
    };
    let cuPeriod = { startDate: currentPeriod?.intervalStart, endDate: currentPeriod?.intervalEnd };
    ProfileAPI.sendApprovalRequest(cuPeriod, data, project?.workspace).then(
      (data) => {
        setLoading(false);
        getIntervals('waiting');
        KoToast.success(`Request sent successfully!`);
        setSubmitModal(false);
        dispatch(getApprovalCount());
        getWorkspaces();
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 80,
    render: (text, row) => {
      return <div className={`tableBtn columnsRight`} onClick={() => { form.resetFields(); setCurrentRecord(row); }}>
        <KoTooltips title={'Edit'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'EditOutlined'} />} onClick={() => setModal(true)} />
        </KoTooltips>
        <KoTooltips title={'Delete'}>
          <KoButton className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} onClick={() => setDeleteModal(true)} />
        </KoTooltips>
      </div>;
    }
  }];

  return (
    <div className={`${currentPeriod ? styles.periods : styles.periodsNonHover} customTagLinkNonHover`}>
      {isLoading && <KoLoader />}
      {intervals &&  currentPeriod ? <>
        <div className={styles.periodsList}>
          <div className={styles.periodsListMain}>
            {intervals?.map((inter, index) => {
              return (
                <div key={index}>
                  <ul>
                    <li onClick={() => updateCurrentPeriod(inter, project?.workspace)} className={`${currentPeriod?.startDate === inter?.startDate ? styles.active : ''}`}>
                      <div className={styles.periodsListWrapper}>
                        {/* {currentPeriod?.intervalId === intervals?.intervalId && <KoIcon width={22} height={22} name={'TicklineOutlined'} />} */}
                        <KoText className={styles.periodsListText} text={`${formatDateRange(inter?.intervalStart, inter?.intervalEnd)}`} />
                      </div>
                      {inter?.status === 0 && <div className={styles.draft}>
                        <KoText text={'Draft'} />
                      </div>}
                      {(inter?.status === 1) && <div className={styles.inprogress}>
                        <KoText text={'Waiting'} />
                      </div>}
                      {(inter?.status === 2) && <div className={styles.approved}>
                        <KoText text={'Approved'} />
                      </div>}
                      {(inter?.status === 3) && <div className={styles.rejected}>
                        <KoText text={'Rejected'} />
                      </div>}
                      {(inter?.status === 4) && <div className={styles.overdue}>
                        <KoText text={'Overdue'} />
                      </div>}
                    </li>
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles.table}>
          <div className={`${styles.tablePart} tableCard`}>
            <div className={styles.tableHeader}>
              {currentPeriod &&
              <div className={styles.tableHeaderTitle}>
                <KoTitle text={`Worklogs`} level={5} />
                {logsByDateRange?.approvelRequestedDate && <KoText className={'fs-size-13'} text={`Requested on:`} />}
                {logsByDateRange?.approvelRequestedDate && <KoTag color={ currentPeriod?.status === 1 ? "yellow" : "geekblue"} value={<KoDateFormatter className={'fs-size-11'} data={logsByDateRange?.approvelRequestedDate} />} />}
                {currentPeriod?.status === 2 &&
                <>
                  {logsByDateRange?.approvedDate && <KoText className={'fs-size-13'} text={`Approved at: `} />}
                  {logsByDateRange?.approvedDate && <KoTag className={styles.workLogSummaryItemTag} color="green" value={
                    <KoDateFormatter className={'fs-size-11'} data={logsByDateRange?.approvedDate} />} />}
                </>
                }
                {currentPeriod?.status === 3 ?
                  <>
                    {logsByDateRange?.rejectedDate && <KoText className={'fs-size-13'} text={`Rejected at: `} />}
                    {logsByDateRange?.rejectedDate && <KoTag className={styles.workLogSummaryItemTag} color="red" value={
                      <KoDateFormatter className={'fs-size-11'} data={logsByDateRange?.rejectedDate} /> } />}
                  </>
                  : null
                }
                {(currentPeriod?.status === 3  || currentPeriod?.status === 2 || currentPeriod?.status === 1) && logsByDateRange?.approverProfile?.firstName &&
                <>
                  <KoText className={styles.userName}  text={currentPeriod?.status === 3 ? "Rejected by: " : currentPeriod?.status === 2 ? "Approved by: " : "Approver : "} />
                  <KoTag className={styles.userTag} color={currentPeriod?.status === 3 ? "red" :  currentPeriod?.status === 2 ? "green" : "yellow" }value={ <div className={`${styles.userTextIcon} fs-size-11`}>
                    <div className={`${styles.circle}  ${logsByDateRange ?
                      logsByDateRange?.approverProfile?.firstName?.charAt(0).toLowerCase() : 'a'}`}>
                      {logsByDateRange?.approverProfile?.['logo'] ?
                        <KoDP logo={logsByDateRange?.approverProfile?.['logo']} className={styles.profile} width={15} height={15} />
                        :
                        <KoText className={`${styles.letter} fs-size-11`} text={logsByDateRange?.approverProfile?.firstName?.charAt(0)} />}
                    </div>
                    <KoText className={`${styles.userName} fs-size-11`}  text={`${logsByDateRange?.approverProfile?.firstName ? logsByDateRange?.approverProfile?.firstName : ''} ${logsByDateRange?.approverProfile?.lastName ? logsByDateRange?.approverProfile?.lastName : ''}`}/>
                  </div>} />
                </>
                  
                }
              </div>
              }
        
            </div>
            <div className={styles.workLogSummary}>
              {currentPeriod?.status === 3 ?
                <div className={`${styles.panelHeaderTitle} ${styles.panelRejected}`}>
                  <KoText text={`Reason: ${logsByDateRange?.comments}`} className={styles.panelRejectedTag} />
                </div> : <div>&nbsp;</div>}
              <div className={`${styles.workLogSummaryItem} customTagLinkNonHover`}>
                <div className={styles.workLogSummaryItemTitle}>
                  <div className={styles.workLogSummaryItemTagWrapper}>
                    <KoText text={`Billable Hours`} className={styles.workLogItemTitle} />
                    <KoTag value={`With Tickets`} color="color-1" custom={true} count={`${logsByDateRange?.ticketLogs?.totalBillableWorkHours ? logsByDateRange?.ticketLogs?.totalBillableWorkHours : '0:00'}`} />
                    <KoTag value={`Without Tickets `} color="color-2" custom={true} count={`${logsByDateRange?.nonticketLogs?.totalBillableWorkHours ? logsByDateRange?.nonticketLogs?.totalBillableWorkHours : '0:00'}`}  />
                    <KoTag value={`Total Hours`} color="draft" custom={true} count={`${logsByDateRange?.totalBillableWorkHours ? logsByDateRange?.totalBillableWorkHours : '0:00'} `} />
                  </div>
                </div>
                <div className={styles.workLogSummaryItemTitle}>
                  <div className={styles.workLogSummaryItemTagWrapper}>
                    <KoText text={`Non - Billable Hours`} className={styles.workLogItemTitle} />
                    <KoTag color="color-1" custom={true} value={`With Tickets`} count={`${logsByDateRange?.ticketLogs?.totalNonBillableWorkHours ? logsByDateRange?.ticketLogs?.totalNonBillableWorkHours : '0:00'}`} />
                    <KoTag color="color-2" custom={true} value={`Without Tickets`} count={`${logsByDateRange?.nonticketLogs?.totalNonBillableWorkHours ? logsByDateRange?.nonticketLogs?.totalNonBillableWorkHours : '0:00'}`}  />
                    <KoTag color="draft" custom={true} value={`Total Hours`} count={`${logsByDateRange?.totalNonBillableWorkHours ? logsByDateRange?.totalNonBillableWorkHours : '0:00'}`} />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.tableHeaderBtns}>
              {(currentPeriod?.status === 0 || currentPeriod?.status === 4 || currentPeriod?.status === 5 ) && <KoButton disabled={totalLogs?.length === 0}  type='primary' label='Submit Timesheet' onClick={() => { setSubmitModal(true); }} />}
              {(currentPeriod?.status === 3 ) && <KoButton type='primary' label='Move to Draft' onClick={() => { cancelTimeSheet(project);}} />}
              {currentPeriod?.status === 1 && <KoButton color="danger" variant="solid" type='primary' label='Cancel Timesheet' onClick={() => { setCurrentRecord(project); setCancelConfirm(true); }} />}
              {(!currentPeriod?.status || currentPeriod?.status === 0 || currentPeriod?.status === 5 ||  currentPeriod?.status === 4) &&
                  <KoButton type='primary' label='Log Work' icon={<KoIcon color="#FFF" name="PlusOutlined" width={18} height={18} />} onClick={() => { form.resetFields(); setModal(true); setCurrentRecord(project); }} />}
            </div>
            <KoTable
              rowKey="workLogId"
              onExtraClick={onExtraClick}
              maxHeight={112}
              extraColumnsRight={currentPeriod?.status !== 1 && currentPeriod?.status !== 2 && currentPeriod?.status !== 3 && columnsRight}
              data={{ columns: KoTicketTable_COLUMNS, rows: totalLogs }}
            />
          </div>
        </div>
      </> : <KoEmpty title={`No logs found`}
        subText={` `} />}
      <KoModal
        title={`${currentRecord ? 'Update' : 'Add new'} Time sheet ${currentPeriod && formatDateRange(currentPeriod?.intervalStart, currentPeriod?.intervalEnd)}`}
        centered
        open={isOpen}
        width={880}
        onClose={() => { setModal(false); setCurrentRecord(null); form.resetFields(); }}
        // maskClosable={false}
        height={650}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => { setModal(false); setCurrentRecord(null); form.resetFields(); }} />,
          <KoButton key='add_entry' loading={isLoading} type='primary' label={currentRecord?.workLogId ? 'Update Log' : 'Add Log'}
            onClick={() => form.submit()} />
        ]}
      >
        {currentRecord && <TimeSheetCurd currentPeriod={currentPeriod} workspace={project} initialValues={currentRecord} form={form} handleFinish={handleFinish} setModal={setModal} />}
      </KoModal>
      <KoModal
        title={`Send for approval`}
        centered
        open={openSubmitModal}
        width={600}
        onClose={() => setSubmitModal(!openSubmitModal)}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setSubmitModal(!openSubmitModal)} />,
          <KoButton key='RequestApproval' loading={isLoading} type='primary' label={'Request Approval'}
            onClick={() => sendApprovalRequest()} />
        ]}
      >
        <div className={styles.projectManagers}>
          {project?.profile?.firstName && <div className={styles.projectManagersText}>
            <KoText level={5} text='Request approval from the default reporting manager,' />
            <div className={` ${styles.tag} ${styles.reportingManager} profileChar`}>
              <div className={`${styles.circleDPsmall}  ${project?.profile?.firstName?.charAt(0) ? project?.profile?.firstName?.charAt(0).toLowerCase() : 'a'}`}>
                {project?.profile?.logo ?
                  <KoDP logo={project?.profile['logo']} className={styles.profile} width={20} height={20} />
                  :
                  <KoText className={`${styles.letter}`} text={project?.profile?.firstName?.charAt(0)} />}
              </div>
              <div className={styles.tagTextWrapper}>
                <KoText text={`${project?.profile?.firstName ? project?.profile?.firstName : ''} ${project?.profile?.lastName ? project?.profile?.lastName : ''}`} className={styles.panelHeaderTextName} />
                <KoText text={`(${project?.profile?.email ? project?.profile?.email : ''})`}  />
              </div>
            </div>
            <KoText level={5} text='or select another approver' />
          </div>}
          {!project?.profile?.firstName &&  <KoText className={styles.projectManagersText} level={5} text='Select Approver' />}
          <div className={styles.approver}>
            <KoUserSelect onChange={v => setSelectedApprover(v)} users={users['data']} placeholder='Select approver' />
          </div>
          <KoText className={styles.projectManagersapproveText} text='to approve this timesheet entry' />
        </div>
      </KoModal>
      <KoModal
        title={`Delete Log Entry`}
        centered
        open={isOpenDelete}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setDeleteModal(false); }}
        onClose={() => { setCurrentRecord(); setDeleteModal(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(!isOpenDelete)} />,
          <KoButton key='reset' loading={isLoading} color="danger" variant="solid" type='primary' label='Delete' onClick={() => handleFinishDelete()} />
        ]}
      >
        <div className={styles.suspend}>
          <KoTitle level={5} text={`Are you sure you want to delete this Log?`} />
          <KoText text={`This action is irreversible, and it will result in the removal of their associated data.`} />
        </div>
      </KoModal>

      <KoModal
        title={`Worklog History`}
        centered
        open={isOpenWorkLog}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setWorkLogModal(false); }}
        onClose={() => { setCurrentRecord(); setWorkLogModal(false); }}
        width={850}
        footer={[
          <KoButton key='cancel' label='Close' onClick={() => setWorkLogModal(false)} />
        ]}
      >
        <div className={styles.suspend}>
          <KoTable extraColumnsRight={showCreate && columnsRight} data={{ columns: WORKLOG_COLUMNS, rows: workLogHistory }} />
        </div>
      </KoModal>

      <KoModal
        title={`Cancel Timesheet?`}
        centered
        open={cancelConfirm}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setCancelConfirm(false); }}
        onClose={() => { setCurrentRecord(); setCancelConfirm(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setCancelConfirm(false)} />,
          <KoButton key='reset' loading={isLoading} color="danger" variant="solid" type='primary' label='Cancel Timesheet' onClick={() => cancelTimeSheet(project)} />
        ]}
      >
        <div className={styles.suspend}>
          <KoTitle level={5} text={`Are you sure you want to cancel this timesheet?`} />
          <KoText text={`This action is irreversible, and it will result in the removal of their associated data.`} />
        </div>
      </KoModal>
    </div>
  );
}
